// QA-only mock for the relationship-strength intro-paths surface. Enabled via
// `localStorage.rsMock = '1'` (or `?rsMock=1`; the SPA router strips the param,
// so localStorage is the reliable toggle). Synthesises a per-path `level`, person
// `emails`, origin integration flags, and signal evidence so the enriched card
// (badge + met-criteria + email button + connect/copy nudge) can be validated
// before the BE emits these fields. Remove this module once the BE lands.
//
// Keys are camelCase because the network base query camelCases the response
// before this runs.

const LEVELS = ['warm', 'known', 'cold', 'inferred', 'unknown'];

export const isConnectionPathsMockEnabled = () => {
  try {
    if (typeof window === 'undefined') return false;
    if (new URLSearchParams(window.location.search).has('rsMock')) return true;
    return window.localStorage?.getItem('rsMock') === '1';
  } catch {
    return false;
  }
};

const mockSignal = (idx) =>
  idx === 0
    ? { kind: 'signal', type: 'linkedin_connection', connectedAt: 1577836800000 }
    : {
        kind: 'signal',
        type: 'work_overlap',
        organizationName: 'Globex',
        overlapFrom: '2019-01-01',
        overlapTo: '2021-06-01',
        bothCurrentlyAtCompany: false,
      };

const decorateItem = (item, i) => {
  const persons = (item.path || []).filter((n) => n.kind === 'user' || n.kind === 'contact');
  if (persons.length === 0) return item;

  const path = [];
  persons.forEach((person, idx) => {
    const node = { ...person };
    if (idx === 0) node.linkedinConnected = false; // origin missing LinkedIn → connect/copy nudge
    if (!node.emails || node.emails.length === 0) {
      node.emails =
        idx === persons.length - 1
          ? [`${node.kind}-${node.id}@example.com`, `${node.kind}-${node.id}.alt@example.com`] // target: multi → dropdown
          : [`${node.kind}-${node.id}@example.com`];
    }
    path.push(node);
    if (idx < persons.length - 1) path.push(mockSignal(idx)); // signal between each pair → met-criteria rows
  });

  return { ...item, level: LEVELS[i % LEVELS.length], path };
};

export const decorateConnectionPathsMock = (items) =>
  isConnectionPathsMockEnabled() ? items.map(decorateItem) : items;
